/**
 * Created by Anastasiya on 15.06.2024
 */

const PixelOfferWindow = CleverappsWindow.extend({
    onWindowLoaded: function (offer) {
        this.offer = offer.logic;

        const styles = cleverapps.styles.PixelOfferWindow;

        this.createContent();

        this._super({
            name: "PixelOfferWindow",
            title: Messages.get("PixelOfferWindow.name"),
            content: this.content,
            foreground: bundles.windows.frames.window_foreground_png,
            styles: styles.window,
            openSound: bundles.pixelofferwindow.urls.showup_sfx,
            button: {
                text: this.getPriceText(),
                width: styles.button.width,
                height: styles.button.height,
                onPressed: this.offer.buyProduct.bind(this.offer)
            }
        });

        this.buttons.setLocalZOrder(1);

        cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");
        this.offer.on("onPurchaseFinished", (success) => {
            if (success) {
                this.onRewardReady();
            } else {
                this.bottomButton.setString(this.getPriceText());
            }
        }, this);

        this.onResize();
    },

    createWindowButtons: function () {
        this.params.button.onClicked = this.params.button.onPressed || this.close.bind(this);
        this.bottomButton = new BottomButton(this.params.button);

        return this.bottomButton;
    },

    getPriceText: function () {
        const product = this.offer.getProduct();
        return product ? product.getCurrentPrice() : `$$${this.offer.getPrice()}`;
    },

    getPerson: function () {
        return cleverapps.persons.choose("seller", "worker");
    },

    onResize: function () {
        this._super();

        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            this.balloon.setVisible(true);
        } else {
            this.balloon.setVisible(false);
        }
    },

    onRewardReady: function () {
        this.close();

        cleverapps.focusManager.display({
            focus: "RewardWindow",
            stack: true,
            action: (f) => {
                new RewardWindow(this.offer.getReward(), { event: cleverapps.EVENTS.EARN.PURCHASE });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    createContent: function () {
        this.content = new cc.Node();
        this.content.setAnchorPoint(0.5, 0.5);
        this.content.setContentSize2(cleverapps.styles.PixelOfferWindow);

        this.createDescription();
        this.createGoods();
        this.createOfferBalloon();

        this.showUpAnimation();
    },

    showUpAnimation: function () {
        const delay = 0;

        this.lots.setScale(0);
        this.lots.runAction(new cc.Sequence(
            new cc.DelayTime(delay + 0.5),
            new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut())
        ));
    },

    createDescription: function () {
        const styles = cleverapps.styles.PixelOfferWindow.description;

        const texts = [];
        const offerReward = this.offer.getReward();
        Object.keys(offerReward).forEach((reward) => {
            const rewardData = {};
            rewardData[reward] = offerReward[reward];
            let name;
            let amount;
            Object.keys(rewardData).forEach((key) => {
                if (key === "unit") {
                    name = cleverapps.unitsLibrary.getUnitName(rewardData[key]);
                    amount = rewardData[key].amount;
                } else {
                    name = Messages.get(`PixelOfferWindow.description.reward.${key}`);
                    amount = rewardData[key];
                }
            });
            texts.push({ name, amount });
        });

        const part1 = cleverapps.UI.generateOnlyText(Messages.get("PixelOfferWindow.description.first"), cleverapps.styles.FONTS.PIXEL_OFFER_TEXT);
        const part1reward = cleverapps.UI.generateOnlyText(`x${texts[0].amount} ${texts[0].name}`, cleverapps.styles.FONTS.PIXEL_OFFER_REWARD_TEXT);

        const firstLine = new cleverapps.Layout([part1, part1reward], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.spaceMargin
        });

        let secondLine;

        if (texts[1]) {
            const part2 = cleverapps.UI.generateOnlyText(Messages.get("PixelOfferWindow.description.second"), cleverapps.styles.FONTS.PIXEL_OFFER_TEXT);
            const part2reward = cleverapps.UI.generateOnlyText(`x${texts[1].amount} ${texts[1].name}`, cleverapps.styles.FONTS.PIXEL_OFFER_REWARD_TEXT);

            secondLine = new cleverapps.Layout([part2, part2reward], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.spaceMargin
            });

            this.content.height = cleverapps.styles.PixelOfferWindow.height + styles.lineHeight;
        }

        const descriptionLayout = this.description = new cleverapps.Layout([firstLine, secondLine].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL
        });

        cleverapps.UI.fitToBox(descriptionLayout, styles);

        this.content.addChild(descriptionLayout);
        descriptionLayout.setAlignment(styles);
    },

    createGoods: function () {
        const styles = cleverapps.styles.PixelOfferWindow.goods;

        const lots = [];
        const offerReward = this.offer.getReward();
        Object.keys(offerReward).forEach((reward) => {
            const rewardData = {};
            rewardData[reward] = offerReward[reward];
            const lot = this.createLot(rewardData);
            lots.push(lot);
        });

        const images = [];

        const pattern = new cc.Sprite(bundles.pixelofferwindow.frames.pattern_png);
        const columns = Math.round(styles.lots.width / pattern.width);
        const rows = Math.round(styles.lots.height / pattern.height);

        for (let i = 0; i < columns * rows; i++) {
            const image = new cc.Sprite(bundles.pixelofferwindow.frames.pattern_png);
            images.push(image);
        }

        const bg = new cleverapps.GridLayout(images, {
            columns
        });

        const lotsLayout = this.lots = new cleverapps.Layout(lots, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.itemsMargin
        });
        lotsLayout.setAlignment(styles.lots);

        bg.setAlignment(styles);
        bg.addChild(lotsLayout);

        this.content.addChild(bg);
    },

    createLot: function (reward) {
        const styles = cleverapps.styles.PixelOfferWindow.goods.lot;
        const bg = cleverapps.UI.createScale9Sprite(bundles.pixelofferwindow.frames.tile_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setContentSize2(styles.bg);

        let sprite;
        let amount;
        Object.keys(reward).forEach((key) => {
            if (key === "unit") {
                if (bundles.pixelofferwindow.frames[`${reward[key].code}_png`]) {
                    sprite = new cc.Sprite(bundles.pixelofferwindow.frames[`${reward[key].code}_png`]);
                } else {
                    sprite = UnitView.getUnitImage(reward[key], { preferStatic: true, useLibraryAnchors: true });
                }
                amount = reward[key].amount;
            } else {
                sprite = new cc.Sprite(bundles.pixelofferwindow.frames[`${key}_png`]);
                amount = reward[key];
            }
        });

        sprite.setAlignment(styles.item);
        cleverapps.UI.fitToBox(sprite, styles.item);
        bg.addChild(sprite);

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(`x${amount}`, cleverapps.styles.FONTS.PIXEL_OFFER_TEXT);
        text.setAlignment(styles.amount);
        bg.addChild(text);

        return bg;
    },

    createOfferBalloon: function () {
        const styles = cleverapps.styles.PixelOfferWindow.balloon;

        const balloon = this.balloon = new cc.Sprite(bundles.pixelofferwindow.frames.balloon_png);
        balloon.setAlignment(styles);

        this.content.addChild(balloon);
    },

    listBundles: function () {
        return ["pixelofferwindow"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PIXEL_OFFER_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PIXEL_OFFER_REWARD_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.PIXEL_OFFER_REWARD_COLOR
    }
});

cleverapps.styles.PixelOfferWindow = {
    width: 1000,
    height: 600,

    window: {
        padding: {
            bottom: -45
        },
        contentMargin: {
            bottom: 20
        },
        margin: -30
    },

    description: {
        x: { align: "center" },
        y: { align: "top" },

        width: 850,
        height: 100,

        spaceMargin: 15,
        lineHeight: 40
    },

    goods: {
        x: { align: "center" },
        y: { align: "bottom", dy: -35 },
        itemsMargin: 150,

        lots: {
            x: { align: "center" },
            y: { align: "top", dy: -60 },

            width: 1100,
            height: 620
        },

        lot: {
            bg: {
                width: 350,
                height: 400
            },

            item: {
                x: { align: "center" },
                y: { align: "center", dy: 30 },

                width: 325,
                height: 300
            },

            amount: {
                x: { align: "center" },
                y: { align: "bottom", dy: 20 }
            }
        },

        item: {
            width: 250,
            height: 250,
            maxScale: 1.45
        }
    },

    balloon: {
        x: { align: "right", dx: 560 },
        y: { align: "center", dy: 80 }
    },

    button: {
        width: 350,
        height: 125,
        x: { align: "center" },
        y: { align: "bottom", dy: -110 }
    }
};
